import React from 'react';

import { LoaderPageContent } from '../Loaders/LoaderPageContent';
import { PageContentProps } from './PageContent.types';
import classnames from 'classnames';

export const PageContent: React.FunctionComponent<PageContentProps> = ({ children, loading, className }) => (
  <div className={classnames('content', className)}>{loading ? <LoaderPageContent /> : children}</div>
);
